// extracted by mini-css-extract-plugin
export default {"parent":"style_parent__eqN2y","container":"style_container__0hOs6","frame":"style_frame__rofLA","content":"style_content__DFpjj"};